import React from 'react';

export const pageMeta = {
  "name": "JS D3.js",
  "link": "/javascript/graphics/d3"
};

export default function JavascriptGraphicsD3() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS D3.js</h2>
      <p>Route: /javascript/graphics/d3</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
